// providermanagement.action.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getAllProcedures,
  getProcedureSettings,
} from '@services/api/procedure.api'
import { Procedure } from '@dataTypes/appointment.type'
import { ProcedureSettingsType } from '@dataTypes/procedureSettings.type'

export const fetchAllProcedures = createAsyncThunk<Procedure[], string | null>(
  'api/procedure/get/all',
  async (arg = null, thunkAPI) => {
    // Set a default value for the argument
    try {
      const response = await getAllProcedures()

      if (response.statusCode !== 200) {
        return thunkAPI.rejectWithValue(response.message)
      }

      if (
        response.data &&
        'procedures' in response.data &&
        Array.isArray(response.data.procedures)
      ) {
        return response.data.procedures as Procedure[]
      }

      return thunkAPI.rejectWithValue('Providers not found in the response')
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'An error occurred')
    }
  },
)
export const fetchAllProcedureSettings = createAsyncThunk<
  ProcedureSettingsType[],
  string | null
>('api/procedure_settings/get/all', async (_, thunkAPI) => {
  try {
    const response = await getProcedureSettings()

    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue(response.message)
    }

    if (
      response.data &&
      'procedure_settings' in response.data &&
      Array.isArray(response.data.procedure_settings)
    ) {
      return response.data.procedure_settings as ProcedureSettingsType[]
    }

    return thunkAPI.rejectWithValue('Providers not found in the response')
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.message || 'An error occurred')
  }
})
